import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DocumentsService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-analisis-semanal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './analisis-semanal.component.html',
  styleUrl: './analisis-semanal.component.css'
})
export class AnalisisSemanalComponent implements OnInit, OnChanges {
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;
  listaAlimentos: any;
  listaSuplementos: any;
  listaAlimentosPreparados: any;
  bolGets: any = {
    alimentos: false,
    suplementos: false,
    preparados: false
  }
  analisisSemanal: any;
  periodoSelected = 1;
  env: any = environment
  ngOnInit(): void {
    // this.setArrayAnalisisSemanal();
    this.getAlimentos();
    this.getSuplementos();
    this.getPreparados();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('userInfo', this.userInfo);
    console.log('detallePrograma', this.detallePrograma);
    console.log('detalleCliente', this.detalleCliente);
    if(this.bolGets.alimentos && this.bolGets.suplementos && this.bolGets.preparados) {
      this.setArrayAnalisisSemanal();
    }
  }
  isValueNaN(value: any): boolean {
    return isNaN(value);
  }
  getColorByPeriod(periodo: number): string {
    const colors = ['#ffcccc80', '#cce5ff7b', '#d4edda79', '#fff3cd79', '#f8d7da7d']
    return colors[periodo % colors.length]; // Rotar colores si hay más periodos que colores
  }

  constructor(
    private documentService: DocumentsService,
  ) { }

  getAlimentos() 
  {
    const filters: any = {
      // "documentContainerId": this.userInfo.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    let should: any = []
    should = [
      {
        "match_phrase": {
          "documentContainerId.keyword": this.userInfo.documentContainerId
        }
      },
      {
        "match_phrase": {
          "documentContainerId.keyword": this.env.empresaBaseId
        }
      }
    ]
    filtersQuery.push({"bool": { should }})
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(this.env.businessId, 'alimento', query).subscribe({
        next: (data: any) => {
          console.log('alimentos', data)
          this.listaAlimentos = data;
          this.bolGets.alimentos = true;
          if(this.bolGets.alimentos && this.bolGets.suplementos && this.bolGets.preparados) {
            this.setArrayAnalisisSemanal();
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1000);
  }
    
  getSuplementos()
  {
    const filters: any = {
      // "documentContainerId": this.userInfo.documentContainerId,
      // "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    let should: any = []
    should = [
      {
        "match_phrase": {
          "documentContainerId.keyword": this.userInfo.documentContainerId
        }
      },
      {
        "match_phrase": {
          "documentContainerId.keyword": this.env['empresaBaseId']
        }
      }
    ]
    filtersQuery.push({"bool": { should }})
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, 'suplemento', query).subscribe({
        next: (data: any) => {
          console.log('suplementos', data)
          this.listaSuplementos = data;
          this.bolGets.suplementos = true;
          if(this.bolGets.alimentos && this.bolGets.suplementos && this.bolGets.preparados) {
            this.setArrayAnalisisSemanal();
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1500);
  }

  getPreparados()
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    let should: any = []
    should = [
      {
        "match_phrase": {
          "documentContainerId.keyword": this.userInfo.documentContainerId
        }
      },
      {
        "match_phrase": {
          "documentContainerId.keyword": this.env.empresaBaseId
        }
      }
    ]
    //debugger
    filtersQuery.push({"bool": { should }})

    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(this.env.businessId, 'preparado', query).subscribe({
        next: (data: any) => {
          console.log('preparados', data)
          this.listaAlimentosPreparados = data;
          this.bolGets.preparados = true;
          if(this.bolGets.alimentos && this.bolGets.suplementos && this.bolGets.preparados) {
            this.setArrayAnalisisSemanal();
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
    }, 1000);
  }
  

  analisisSemanalProgramas: any[] = [];
  setArrayAnalisisSemanal(): void {
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'alimentosDiaCliente').subscribe((res: any) => {
      console.log('alimentosDiaCliente', res.content)
      let alimentacionDias: any = res.content

      this.analisisSemanalProgramas = [];
      for(let programa of this.detalleCliente.expediente.programas) {
        this.analisisSemanal = [];
        const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
        const fechaFin = new Date(fechaInicio);
        fechaFin.setDate(fechaFin.getDate() + (6)); // Incrementar la fecha para el siguiente periodo
        let diaActual = new Date(fechaInicio);
        let analisisSemana = this.inicializarAnalisisSemana(fechaInicio, fechaFin);

        for (let detalleDia of programa.configuracionMacrosXdia) {
          // suma de meta semanal
          analisisSemana.metaSemanal.calorias = analisisSemana.metaSemanal.calorias + Number(detalleDia.calorias);
          analisisSemana.metaSemanal.carbohidratos = analisisSemana.metaSemanal.carbohidratos + Number(detalleDia.carbsGramos);
          analisisSemana.metaSemanal.proteinas = analisisSemana.metaSemanal.proteinas + Number(detalleDia.proteGramos);
          analisisSemana.metaSemanal.grasas = analisisSemana.metaSemanal.grasas + Number(detalleDia.grasaGramos);

          let indexAlimentacionDia = alimentacionDias.findIndex((alimentacionDia: any) => alimentacionDia.dia === detalleDia.dia && alimentacionDia.programaId === programa.configuracionPrograma.id);
          let alimentacionArray;
          if(indexAlimentacionDia != -1) {
            alimentacionArray = {...alimentacionDias[indexAlimentacionDia]};
          } else {
            alimentacionArray = {
              alimentosDesayuno: [],
              alimentosSnack1: [],
              alimentosComida: [],
              alimentosSnack2: [],
              alimentosCena: [],
              dia: detalleDia.dia,
              fecha: detalleDia.fecha,
              periodo: detalleDia.periodo
            }
          }
          // console.log('alimentacionArray', alimentacionArray);
          // Calculo de macros restantes por día
          const calculo = this.calcularMacrosRestantesPorDia(alimentacionArray, detalleDia);
          analisisSemana.macrosRestantesPorDia.push(calculo.macrosRestantesPorDia);
          // Agrega alimentación, consumo por día y consumo por categoría por día
          analisisSemana.alimentacion.push(alimentacionArray);
          analisisSemana.consumoPorDia.push(calculo.totalConsumidoDia);
          analisisSemana.consumoDiarioPorCate.push(calculo.totalConsumidoPorCategoriaDia);
          // Suma de suplementos asignados
          let suplementosAsignados = detalleDia.planSuplementacion ? detalleDia.planSuplementacion.length : 0;
          analisisSemana.suplementosAsignados += suplementosAsignados;
          // Suma de suplementos tomados
          let suplementosTomados = alimentacionArray['suplementos'] ? alimentacionArray['suplementos'].length : 0;
          analisisSemana.suplementosTomados += suplementosTomados;

          if(diaActual < fechaFin) {
            diaActual.setDate(diaActual.getDate() + 1);
          } else {
            // Calcular meta diaria
            analisisSemana.metaDiaria = {
              calorias: analisisSemana.metaSemanal.calorias / 7,
              carbohidratos: analisisSemana.metaSemanal.carbohidratos / 7,
              proteinas: analisisSemana.metaSemanal.proteinas / 7,
              grasas: analisisSemana.metaSemanal.grasas / 7
            }
            // Calcular balance semanal
            // console.log('analisisSemana.macrosRestantesPorDia', analisisSemana.macrosRestantesPorDia);
            for(let macrosRestantesPorDia of analisisSemana.macrosRestantesPorDia) {
              // console.log('macrosRestantesPorDia', macrosRestantesPorDia);
              analisisSemana.balanceSemanal.calorias = analisisSemana.balanceSemanal.calorias + macrosRestantesPorDia.calorias;
              analisisSemana.balanceSemanal.carbohidratos = analisisSemana.balanceSemanal.carbohidratos + macrosRestantesPorDia.carbohidratos;
              analisisSemana.balanceSemanal.proteinas = analisisSemana.balanceSemanal.proteinas + macrosRestantesPorDia.proteinas;
              analisisSemana.balanceSemanal.grasas = analisisSemana.balanceSemanal.grasas + macrosRestantesPorDia.grasas;
            }
            // Calcular consumo semanal
            analisisSemana.consumoPorDia.forEach(consumoDia => {
              analisisSemana.consumoSemanal.calorias = analisisSemana.consumoSemanal.calorias + consumoDia.calorias;
              analisisSemana.consumoSemanal.carbohidratos = analisisSemana.consumoSemanal.carbohidratos + consumoDia.carbohidratos;
              analisisSemana.consumoSemanal.proteinas = analisisSemana.consumoSemanal.proteinas + consumoDia.proteinas;
              analisisSemana.consumoSemanal.grasas = analisisSemana.consumoSemanal.grasas + consumoDia.grasas;
            });
            // Calcular consumo diario
            analisisSemana.consumoDiario = {
              calorias: analisisSemana.consumoSemanal.calorias / 7,
              carbohidratos: analisisSemana.consumoSemanal.carbohidratos / 7,
              proteinas: analisisSemana.consumoSemanal.proteinas / 7,
              grasas: analisisSemana.consumoSemanal.grasas / 7
            }
            // Calular consumo semanal por categoría
            analisisSemana.consumoDiarioPorCate.forEach(consumoDiaCate => {
              analisisSemana.consumoSemanalPorCate.proteinas.origenAnimal += consumoDiaCate.proteinas.origenAnimal;
              analisisSemana.consumoSemanalPorCate.proteinas.lacteos      += consumoDiaCate.proteinas.lacteos;
              analisisSemana.consumoSemanalPorCate.proteinas.suplementos  += consumoDiaCate.proteinas.suplementos;
              analisisSemana.consumoSemanalPorCate.proteinas.otros        += consumoDiaCate.proteinas.otros;

              analisisSemana.consumoSemanalPorCate.carbohidratos.verduras       += consumoDiaCate.carbohidratos.verduras;
              analisisSemana.consumoSemanalPorCate.carbohidratos.frutas         += consumoDiaCate.carbohidratos.frutas;
              analisisSemana.consumoSemanalPorCate.carbohidratos.granosCereales += consumoDiaCate.carbohidratos.granosCereales;
              analisisSemana.consumoSemanalPorCate.carbohidratos.lacteos        += consumoDiaCate.carbohidratos.lacteos;
              analisisSemana.consumoSemanalPorCate.carbohidratos.grasas         += consumoDiaCate.carbohidratos.grasas;
              analisisSemana.consumoSemanalPorCate.carbohidratos.otros          += consumoDiaCate.carbohidratos.otros;

              analisisSemana.consumoSemanalPorCate.grasas.aceites       += consumoDiaCate.grasas.aceites;
              analisisSemana.consumoSemanalPorCate.grasas.origenVegetal += consumoDiaCate.grasas.origenVegetal;
              analisisSemana.consumoSemanalPorCate.grasas.origenAnimal  += consumoDiaCate.grasas.origenAnimal;
              analisisSemana.consumoSemanalPorCate.grasas.lacteos       += consumoDiaCate.grasas.lacteos;
              analisisSemana.consumoSemanalPorCate.grasas.otros         += consumoDiaCate.grasas.otros;

              analisisSemana.consumoSemanalPorCate.alcoholCalorias += consumoDiaCate.alcoholCalorias;
            });
            // calcular porcentaje de consumo por categoria
            analisisSemana.porcentajeConsumoPorCate = {
              proteinas: {
                origenAnimal: (analisisSemana.consumoSemanalPorCate.proteinas.origenAnimal / analisisSemana.consumoSemanal.proteinas) * 100,
                lacteos: (analisisSemana.consumoSemanalPorCate.proteinas.lacteos / analisisSemana.consumoSemanal.proteinas) * 100,
                suplementos: (analisisSemana.consumoSemanalPorCate.proteinas.suplementos / analisisSemana.consumoSemanal.proteinas) * 100,
                otros: (analisisSemana.consumoSemanalPorCate.proteinas.otros / analisisSemana.consumoSemanal.proteinas) * 100
              },
              carbohidratos: {
                verduras: (analisisSemana.consumoSemanalPorCate.carbohidratos.verduras / analisisSemana.consumoSemanal.carbohidratos) * 100,
                frutas: (analisisSemana.consumoSemanalPorCate.carbohidratos.frutas / analisisSemana.consumoSemanal.carbohidratos) * 100,
                granosCereales: (analisisSemana.consumoSemanalPorCate.carbohidratos.granosCereales / analisisSemana.consumoSemanal.carbohidratos) * 100,
                lacteos: (analisisSemana.consumoSemanalPorCate.carbohidratos.lacteos / analisisSemana.consumoSemanal.carbohidratos) * 100,
                grasas: (analisisSemana.consumoSemanalPorCate.carbohidratos.grasas / analisisSemana.consumoSemanal.carbohidratos) * 100,
                otros: (analisisSemana.consumoSemanalPorCate.carbohidratos.otros / analisisSemana.consumoSemanal.carbohidratos) * 100
              },
              grasas: {
                aceites: (analisisSemana.consumoSemanalPorCate.grasas.aceites / analisisSemana.consumoSemanal.grasas) * 100,
                origenVegetal: (analisisSemana.consumoSemanalPorCate.grasas.origenVegetal / analisisSemana.consumoSemanal.grasas) * 100,
                origenAnimal: (analisisSemana.consumoSemanalPorCate.grasas.origenAnimal / analisisSemana.consumoSemanal.grasas) * 100,
                lacteos: (analisisSemana.consumoSemanalPorCate.grasas.lacteos / analisisSemana.consumoSemanal.grasas) * 100,
                otros: (analisisSemana.consumoSemanalPorCate.grasas.otros / analisisSemana.consumoSemanal.grasas) * 100
              }
            }

            // % de cumplimiento
            analisisSemana.porcentajeCumplimiento = {
              calorias: (analisisSemana.consumoSemanal.calorias / analisisSemana.metaSemanal.calorias) * 100,
              carbohidratos: (analisisSemana.consumoSemanal.carbohidratos / analisisSemana.metaSemanal.carbohidratos) * 100,
              proteinas: (analisisSemana.consumoSemanal.proteinas / analisisSemana.metaSemanal.proteinas) * 100,
              grasas: (analisisSemana.consumoSemanal.grasas / analisisSemana.metaSemanal.grasas) * 100
            }

            // % de cumplimiento de suplementos
            analisisSemana.porcentajeCumplimientoSuplementos = (analisisSemana.suplementosTomados / analisisSemana.suplementosAsignados) * 100;

            analisisSemana.periodo = detalleDia.periodo;
            this.analisisSemanal.push(analisisSemana);

            // Reiniciar valores
            fechaInicio.setDate(fechaInicio.getDate() + 7); // Incrementar la fecha para el siguiente periodo
            fechaFin.setDate(fechaFin.getDate() + 7); // Incrementar la fecha para el siguiente periodo
            diaActual.setDate(diaActual.getDate() + 1);
            analisisSemana = this.inicializarAnalisisSemana(fechaInicio, fechaFin);
          }
        }

        let analisisSemanalPrograma = {
          configuracionPrograma: programa.configuracionPrograma,
          fechaInicio: new Date(programa.periodos[0].fechaInicioDate).toISOString(),
          fechaFin: new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate).toISOString(),
          analisisSemanal: this.analisisSemanal
        }
        this.analisisSemanalProgramas.push(analisisSemanalPrograma);
        this.analisisSemanal = [];
      }
      this.getProgramaActual();
      console.log('analisisSemanalProgramas', this.analisisSemanalProgramas);
    });
  }
  idProgramaSelected: any;
  analisisSemanalProgramaSelected: any;
  getProgramaActual() {
    this.idProgramaSelected = this.analisisSemanalProgramas[this.analisisSemanalProgramas.length - 1].configuracionPrograma.id;
    const hoy = new Date();
    this.analisisSemanalProgramas.forEach((programa: any) => {
      const fechaInicio = new Date(programa.fechaInicio);
      const fechaFin = new Date(programa.fechaFin);
      if (hoy >= fechaInicio && hoy <= fechaFin) {
        this.idProgramaSelected = programa.configuracionPrograma.id;
        this.analisisSemanalProgramaSelected = programa;
      }
    });
    this.getAnalisisSemanalProgramaSelected();
    console.log('idProgramaSelected', this.idProgramaSelected);
  }
  getAnalisisSemanalProgramaSelected() {
    this.analisisSemanalProgramas.forEach((programa: any) => {
      if (programa.configuracionPrograma.id === this.idProgramaSelected) {
        this.analisisSemanalProgramaSelected = programa;
        this.analisisSemanal = programa.analisisSemanal;
      }
    });
  }
  
  inicializarAnalisisSemana(fechaInicio: Date, fechaFin: Date): any {
    return {
      fechaInicioDate: fechaInicio.toISOString(),
      fechaFinDate: fechaFin.toISOString(),
      macrosRestantesPorDia: [] as any[],
      alimentacion: [] as any[],
      metaSemanal: {
        calorias: 0,
        carbohidratos: 0,
        proteinas: 0,
        grasas: 0
      },
      balanceSemanal: {
        calorias: 0,
        carbohidratos: 0,
        proteinas: 0,
        grasas: 0
      },
      consumoPorDia: [] as any[],
      consumoSemanal: {
        calorias: 0,
        carbohidratos: 0,
        proteinas: 0,
        grasas: 0
      },
      consumoDiarioPorCate: [] as any[],
      consumoSemanalPorCate: {
        proteinas: {
          origenAnimal: 0,
          lacteos: 0,
          suplementos: 0,
          otros: 0,
        },
        carbohidratos: {
          verduras: 0,
          frutas: 0,
          granosCereales: 0,
          lacteos: 0,
          grasas: 0,
          otros: 0
        },
        grasas: {
          aceites: 0,
          origenVegetal: 0,
          origenAnimal: 0,
          lacteos: 0,
          otros: 0
        },
        alcoholCalorias: 0
      },
      suplementosAsignados: 0,
      suplementosTomados: 0,
    };
  }
  calcularMacrosRestantesPorDia(alimentacionSemanal, configMacros): {totalConsumidoDia: any, macrosRestantesPorDia: any, totalConsumidoPorCategoriaDia: any} {
    // console.log('alimentacionSemanal', alimentacionSemanal);
    const comidas = [
      'alimentosDesayuno',
      'alimentosSnack1',
      'alimentosComida',
      'alimentosSnack2',
      'alimentosCena'
    ];
    let totalConsumidoDia = {
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    };
    let totalConsumidoPorCategoriaDia = {
      proteinas: {
        origenAnimal: 0,
        lacteos: 0,
        suplementos: 0,
        otros: 0,
      },
      carbohidratos: {
        verduras: 0,
        frutas: 0,
        granosCereales: 0,
        lacteos: 0,
        grasas: 0,
        otros: 0
      },
      grasas: {
        aceites: 0,
        origenVegetal: 0,
        origenAnimal: 0,
        lacteos: 0,
        otros: 0
      },
      alcoholCalorias: 0
    }

    if(alimentacionSemanal) {
      comidas.forEach(comida => {
        // console.log('=============>>>>>>>>>>>>> ', comida);
        alimentacionSemanal[comida].forEach(alimento => {
          // console.log('alimento', alimento);
          let alimentoEncontrado: any;
          if(alimento.documentType === 'alimento') alimentoEncontrado = this.listaAlimentos.find((alimentoLista: any) => alimentoLista.documentId === alimento.documentId);
          if(alimento.documentType === 'suplemento') alimentoEncontrado = this.listaSuplementos.find((alimentoLista: any) => alimentoLista.documentId === alimento.documentId);
          if(alimento.documentType === 'preparado') alimentoEncontrado = this.listaAlimentosPreparados.find((alimentoLista: any) => alimentoLista.documentId === alimento.documentId);
          // console.log('---> alimentoEncontrado', alimentoEncontrado);
          // if(alimento.categoria != alimentoEncontrado.categoria) {
          //   console.log('CATEGORÍA DIFERENTE');
          // }
          totalConsumidoDia.calorias += alimento.calorias;
          totalConsumidoDia.carbohidratos += alimento.carbohidratos;
          totalConsumidoDia.proteinas += alimento.proteinas;
          totalConsumidoDia.grasas += alimento.grasaTotal;

          // categorias de proteínas
          if(alimentoEncontrado.categoria === 'AOA - Muy bajo aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Bajo aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Moderado aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Alto aporte de grasa') {
            totalConsumidoPorCategoriaDia.proteinas.origenAnimal += alimento.proteinas;
          } else if(alimentoEncontrado.categoria === 'Leche descremada' || alimentoEncontrado.categoria === 'Leche semidescremada' || alimentoEncontrado.categoria === 'Leche entera' || alimentoEncontrado.categoria === 'Leche con azúcar') {
            totalConsumidoPorCategoriaDia.proteinas.lacteos += alimento.proteinas;
          } else if(alimentoEncontrado.categoria === 'Proteínas' || alimentoEncontrado.categoria === 'Ganadores de peso') {
            totalConsumidoPorCategoriaDia.proteinas.suplementos += alimento.proteinas;
          } else {
            totalConsumidoPorCategoriaDia.proteinas.otros += alimento.proteinas;
          }

          // categorias de carbohidratos
          if(alimentoEncontrado.categoria === 'Verduras') {
            totalConsumidoPorCategoriaDia.carbohidratos.verduras += alimento.carbohidratos;
          } else if(alimentoEncontrado.categoria === 'Frutas') {
            totalConsumidoPorCategoriaDia.carbohidratos.frutas += alimento.carbohidratos;
          } else if(alimentoEncontrado.categoria === 'Cereales sin grasa' || alimentoEncontrado.categoria === 'Cereales con grasa' || alimentoEncontrado.categoria === 'Leguminosas') {
            totalConsumidoPorCategoriaDia.carbohidratos.granosCereales += alimento.carbohidratos;
          } else if(alimentoEncontrado.categoria === 'Leche descremada' || alimentoEncontrado.categoria === 'Leche semidescremada' || alimentoEncontrado.categoria === 'Leche entera' || alimentoEncontrado.categoria === 'Leche con azúcar') {
            totalConsumidoPorCategoriaDia.carbohidratos.lacteos += alimento.carbohidratos;
          } else if(alimentoEncontrado.categoria == 'Aceites y grasas sin proteínas' || alimentoEncontrado.categoria == 'Aceites y grasas con proteínas') {
            totalConsumidoPorCategoriaDia.carbohidratos.grasas += alimento.carbohidratos;
          } else {
            totalConsumidoPorCategoriaDia.carbohidratos.otros += alimento.carbohidratos;
          }

          // categorias de grasas
          if(alimentoEncontrado.categoria === 'Aceites y grasas sin proteínas' || alimentoEncontrado.categoria === 'Aceites y grasas con proteínas') {
            totalConsumidoPorCategoriaDia.grasas.aceites += alimento.grasaTotal;
          } else if(alimentoEncontrado.categoria === 'Verduras' || alimentoEncontrado.categoria === 'Frutas' || alimentoEncontrado.categoria === 'Cereales sin grasa' || alimentoEncontrado.categoria === 'Cereales con grasa' || alimentoEncontrado.categoria === 'Leguminosas') {
            totalConsumidoPorCategoriaDia.grasas.origenVegetal += alimento.grasaTotal;
          } else if(alimentoEncontrado.categoria === 'AOA - Muy bajo aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Bajo aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Moderado aporte de grasa' || alimentoEncontrado.categoria === 'AOA - Alto aporte de grasa') {
            totalConsumidoPorCategoriaDia.grasas.origenAnimal += alimento.grasaTotal;
          } else if(alimentoEncontrado.categoria === 'Leche descremada' || alimentoEncontrado.categoria === 'Leche semidescremada' || alimentoEncontrado.categoria === 'Leche entera' || alimentoEncontrado.categoria === 'Leche con azúcar') {
            totalConsumidoPorCategoriaDia.grasas.lacteos += alimento.grasaTotal;
          } else {
            totalConsumidoPorCategoriaDia.grasas.otros += alimento.grasaTotal;
          }

          // alcohol
          if(alimentoEncontrado.categoria === 'Bebidas alcohólicas') {
            totalConsumidoPorCategoriaDia.alcoholCalorias += alimento.calorias;
          }
        });
      });
    }
    let macrosRestantesPorDia = {
      calorias: configMacros.calorias - totalConsumidoDia.calorias,
      carbohidratos: configMacros.carbsGramos - totalConsumidoDia.carbohidratos,
      proteinas: configMacros.proteGramos - totalConsumidoDia.proteinas,
      grasas: configMacros.grasaGramos - totalConsumidoDia.grasas
    };
    return {totalConsumidoDia, macrosRestantesPorDia, totalConsumidoPorCategoriaDia};
  }
}
